export default "__VITE_ASSET__daf16bf2__"